import { z } from 'zod';
import type { ConditionalTransitionDto } from '../types/ConditionalTransitionDto';

export const conditionalTransitionDtoSchema = z.union([
  z.object({
    id: z.string().uuid(),
    sourceCardId: z.string().uuid(),
    destinationCardId: z.string().uuid(),
    creatorId: z.string().uuid(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
    deletedAt: z.string().datetime({ offset: true }).nullable(),
    type: z.enum(['numberOfCorrectAnswers']),
    value: z.number().int(),
  }),
  z.object({
    id: z.string().uuid(),
    sourceCardId: z.string().uuid(),
    destinationCardId: z.string().uuid(),
    creatorId: z.string().uuid(),
    createdAt: z.string().datetime({ offset: true }),
    updatedAt: z.string().datetime({ offset: true }),
    deletedAt: z.string().datetime({ offset: true }).nullable(),
    type: z.enum(['selectedOption']),
    value: z.string(),
  }),
]) as z.ZodType<ConditionalTransitionDto>;
